import { useCallback, useMemo } from 'react';

import { LineChartSeries } from '@components/patterns/LineChart/types';

const DEFAULT_COLOR = 'var(--primary)';

export interface ColorConfig {
  key: string;
  annotation: string;
  stroke: string;
  fill: {
    from: string;
    to: string;
  };
}

export type GetColorConfigFn = (key: string) => ColorConfig;

export function useColors(
  series: LineChartSeries<any, any>[]
): GetColorConfigFn {
  const colorMap = useMemo(() => {
    return new Map(
      series.map((series) => [series.key, series.color ?? DEFAULT_COLOR])
    );
  }, [series]);

  return useCallback(
    (key: string) => {
      const color = colorMap.get(key) ?? DEFAULT_COLOR;

      return {
        key,
        annotation: `rgba(from ${color} r g b / 0.6)`,
        stroke: `rgba(from ${color} r g b / 0.4)`,
        fill: {
          from: `rgba(from ${color} r g b / 0.15)`,
          to: `rgba(from ${color} r g b / 0.15)`,
        },
      };
    },
    [series]
  );
}
